import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';

import { history } from '_helpers';
import { alertActions } from '_actions';

import DefaultRouting from 'containers/DefaultLayout/DefaultRouting';

import CallbackPage from 'Pages/Misc/CallbackPage';
import SilentRenewPage from 'Pages/Misc/SilentRenewPage';
import SignoutCallbackPage from 'Pages/Misc/SignoutCallbackPage';
import LogoutPage from 'Pages/Unauthorized/Logout';
import LoginPage from 'Pages/Unauthorized/Login';

import Page401 from 'Pages/Misc/Page401';
import Page404 from 'Pages/Misc/Page404';
import Page500 from 'Pages/Misc/Page500';

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <Router history={history}>
        <Switch>
          <Route exact path='/callback' component={CallbackPage} />
          <Route exact path='/silent' component={SilentRenewPage} />
          <Route exact path='/signout-oidc' component={SignoutCallbackPage} />
          <Route exact path='/login' component={LoginPage} />
          <Route exact path='/logout' component={LogoutPage} />
          <Route exact path='/401' name='Page 401' component={Page401} />
          <Route exact path='/404' name='Page 404' component={Page404} />
          <Route exact path='/500' name='Page 500' component={Page500} />
          <Route path='/' name='Home' component={DefaultRouting} />
        </Switch>
      </Router>
    );
  }
}

export default connect(() => ({ }), {
  clear: alertActions.clear
})(App);
